import {
  getRadii,
  getSpacings,
  getPaletteBorder,
  getBreakpointMediaQuery
} from '@oncore/ui/Theme';
import { useNavigate } from 'react-router-dom';
import Alert from '@oncore/ui/Alert';
import Button from '@oncore/ui/Button';
import Typography from '@oncore/ui/Typography';

import { links } from '../chrome';
import styled from 'styled-components';

type TwoFactorAuthBannerProps = {
  isOpen: boolean;
  onClose: () => void;
};

const StyledAlert = styled(Alert)`
  border: none;
  box-shadow: none;
  align-items: center;

  > div:nth-child(2) {
    display: flex;
    align-items: center;

    gap: ${getSpacings('xl')};
  }
  border-radius: ${getRadii('none')};
  border-bottom: 1px solid ${getPaletteBorder('primary')};
  ${getBreakpointMediaQuery('max', 'sm')} {
    flex-wrap: nowrap;
    flex-direction: row-reverse;
    align-items: flex-start;
    > div:nth-child(1) {
      display: none;
    }
    > div:nth-child(2) {
      flex-direction: column;
      align-items: flex-start;
    }

    gap: ${getSpacings('none')};
  }
`;

const StyledTwoFactorAuthButton = styled(Button)`
  flex-shrink: 0;
  flex-grow: 1;

  border-radius: ${getRadii('full')};
`;

const StyledFooter = styled.div`
  display: flex;

  gap: ${getSpacings('lg')};
  ${getBreakpointMediaQuery('max', 'sm')} {
    width: 100%;
  }
`;
const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const TwoFactorAuthBanner = (props: TwoFactorAuthBannerProps) => {
  const { 
    isOpen, 
    onClose 
  } = props;
  const navigate = useNavigate();

  const handleRedirectMfa = () => {
    navigate(links.enrollMfa);
  };

  return (
    <StyledAlert
      isOpen={isOpen}
      onClose={onClose}
      variant="neutral"
      footer={
        <StyledFooter>
          <StyledTwoFactorAuthButton
            size="xl"
            variant="contained"
            onClick={handleRedirectMfa}
          >
            <Typography color="white" weight="medium">
              Enable 2FA
            </Typography>
          </StyledTwoFactorAuthButton>
        </StyledFooter>
      }
    >
      <StyledContent>
        <Typography weight="semibold" color="secondary" size="sm">
          <Typography size="sm" weight="semibold" color="secondary">
            For your security, Two-Factor Authentication (2FA) will be mandatory from 15 July 2025.
          </Typography>
        </Typography>
        <Typography size="sm" color="tertiary">
          Please enable 2FA now to avoid being locked out of your account.
        </Typography>
      </StyledContent>
    </StyledAlert>
  );
};

export default TwoFactorAuthBanner;
